
import {  mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('categories');

export const getCategoryById = mount((localState, categoryId) => {
  return localState.byId[categoryId];
});

export const getCategories = mount((localState, rootState) => {
  return Object.keys(localState.byId).map(categoryId => {
    return getCategoryById(rootState, categoryId);
  })
  .sort((category1, category2) => category1.title.localeCompare(category2.title));
});

export const getCategorySelected = mount((localState, categoryType, rootState) => {
  const selectedCategoryId = localState.categorySelection[categoryType].selectedCategory;

  if(!selectedCategoryId) {
    return null;
  }

  return getCategoryById(rootState, selectedCategoryId);
});



/** WEBPACK FOOTER **
 ** ./src/members/state/categories/selectors.js
 **/